module.exports = __webpack_public_path__ + "static/media/insurance.76e8cc48.png";